import { useHMOStore } from "../hooks/use-hmo-store";
import { IntroFormNoOwnerType } from "./intro-form-no-owner-type";
import { IntroForm } from "./intro-form";

export function IntroFormStep() {
  const providerFeatures = useHMOStore(s => s.providerFeatures);
  const hiddenConsultationOwnerTypeFeature = providerFeatures?.hiddenConsultationOwnerTypeFeature || false;

  return (
    <>
      {hiddenConsultationOwnerTypeFeature ? <IntroFormNoOwnerType /> : <IntroForm />}
    </>
  )

}